import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { groupByLocation, SiteProductData,QueryFilter,SpProductOrLocationExportPayload, locationViewData, SPViewFilterOptions, PaginationOptions } from '../types/solution-participation-types';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersService } from 'src/app/core/services/filters.service';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { UntypedFormControl } from '@angular/forms';
import { skip, Subscription } from 'rxjs';
import { CustomPaginator } from '../sku-groupby-view/CustomPaginatorConfigurationLocation';
import { CustomFilterPipe } from '../pipes/custom-filter.pipe';
import { MatCheckbox } from '@angular/material/checkbox';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { SolutionParticipationService } from '../service/solution-participation.service';
import { SpExcelExportService } from '../service/sp-excelexport.service';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';

@Component({
    selector: 'app-location-drilldown-view',
    templateUrl: './location-drilldown-view.component.html',
    styleUrls: ['./location-drilldown-view.component.scss'],
    providers: [
        CustomFilterPipe,
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }
    ],
    standalone: false
})
export class LocationDrilldownViewComponent implements OnInit {

  private currencySubscription: Subscription | undefined;
  locationsData: SiteProductData[] = [];
  locationDataPaginated: SiteProductData[] = [];

  siteName: string | undefined;
  solutionGroupName: string | undefined;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  searchByLocationInput = new UntypedFormControl;

  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;

  isLoading: boolean = false;

  filteredData: SiteProductData[] = [];
  searchTerm: string = '';

  byDefaultSelectAllRows:boolean=false;
  drillBy:string = '';

  // Define the sort direction objects to store the direction for each column
  sortDirections: { [key: string]: string } = {
    sales: 'desc',
    cases: 'desc'
  };
  sortBy: string = 'sales';
  sortDirection = 'desc';

  exportAll: boolean = false;
  isGroupRowChecked:boolean = false;
  rowSelection: boolean[] = [];
  allRowsSelected: boolean = false;
  currencyCode: string = '';
  locationViewData!: locationViewData;
  viewAdvancedFiltersSubscription: Subscription| undefined;
  viewSelectedAdvancedFilters: SPViewFilterOptions = {
    "accountNumber": [],
    "accountName": [],
    "country": [],
    "state": [],
    "city": [],
    "zipCode": [],
    "brand": [],
    "productGroup":[],
    "productName":[],
    "productSku": [],
  };
  paginationOptions: PaginationOptions = {
    limit: 10,
    page: 1,
    sortBy: "",
    sortOrder: "",
    searchTerm: "",
    tabSelected: ""
  };
  totalRows:number = 0;
  isDownloadingFile:boolean = false;

  selectedIds: string[] = [];
  notSelectedIds: string[] = [];

  spLocationExportFilterPayload!:SpProductOrLocationExportPayload;

  constructor(
    private _filterService: FiltersService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _mixpanelService: MixpanelService,
    private customFilterPipe: CustomFilterPipe,
    private _solutionParticipation: SolutionParticipationService,
    private _spExcelexportService: SpExcelExportService,
    private _currencyUomService: CurrencyUomService,
    private _cdr: ChangeDetectorRef,
  ) { }

  async ngOnInit() {
    this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);
    this.viewAdvancedFiltersSubscription = this._solutionParticipation.getLocationDetailsAdvancedFilters().subscribe(advFilter => this.viewSelectedAdvancedFilters = advFilter);

    if (this.filters?.period != undefined) {
      this._route.queryParams.subscribe(p => {
        this.siteName = p['site']
        this.solutionGroupName = p['solutionGroup'];
        this.isGroupRowChecked = JSON.parse(p['isProductChecked']);
        this.byDefaultSelectAllRows = this.isGroupRowChecked;
        // Set the drillBy value based on the query parameter
        // If drillBy is not provided, default to 'Product'
        //This is used to determine whether to drill down by product or account number.
        //it is used in excel export. the filter is applied based on this value.
        this.drillBy = p['drillBy'] || 'Product';
      });

      if (this.siteName === undefined) {
        this._router.navigate(['/solution-participation-groupBy'], {
          queryParams: {
            groupBy: 'location',
            solutionGroup: this.solutionGroupName,
            isProductChecked :false
          }
        });
      }

     this.spLocationExportFilterPayload = this._solutionParticipation.getSpProductorLocationExportPayload();
     await this.getData();
      // Clear the Search Term
      this.spLocationExportFilterPayload.searchTerm = '';

     this.upDateQueryFilter('SOLUTION', this.solutionGroupName ?? '', '=', 'And');
     const id = this.siteName?.split(" -")[0];
     if(id != undefined)
     this.upDateQueryFilter('SITEID', id ?? '', '=', 'And');

     this.getCurrency();

     this.currencySubscription = this._currencyUomService.selectedCurrency$.pipe(skip(1)).subscribe(async () => {
      this.currencyCode = '';
      this._currencyUomService.setCurrencyLoading(true);

      await this.getData();

      this.getCurrency();
      this._currencyUomService.setCurrencyLoading(false);
      this._cdr.detectChanges();

     });
    }
    else {
      alert('Please apply filters before navigating to Solution Participation')
      this._router.navigate(['/filter']);
    }
  }


  async getData() {
    this.isLoading = true;
    let selectedSiteId = this.siteName?.split(" -")[0];
    let transformedData: SiteProductData[] = [];

    this.locationViewData = await this._solutionParticipation.getByLocationData(this.solutionGroupName,this.viewSelectedAdvancedFilters,this.paginationOptions,selectedSiteId ,true);
    this.spLocationExportFilterPayload.exportType = 'LocationUsage';
    this.spLocationExportFilterPayload.contractModel = this.filters;
    this.totalRows = this.locationViewData.totalUsageLocationCount;

    this.isLoading = false;
    window.scrollTo(0, 0);
    this.filteredData = this.locationsData = this.transformData(this.locationViewData.locations);

    this.updatePageData(0, this.paginator.pageSize);
  }


  ngOnDestroy(): void {
    if (this.filtersSubscription) {
      this.filtersSubscription.unsubscribe();
    }

    if(this.viewAdvancedFiltersSubscription) {
      this.viewAdvancedFiltersSubscription.unsubscribe();
    }
    this.currencySubscription?.unsubscribe();
  }

  onPageChange(event: PageEvent) {
    this.updatePageData(event.pageIndex, event.pageSize);
  }

  updatePageData(pageIndex: number, pageSize: number) {
    const startIndex = pageIndex * pageSize;
    const endIndex = (pageIndex * pageSize) + pageSize;
    this.locationDataPaginated = this.filteredData.slice(startIndex, endIndex);
    if (this.locationDataPaginated.length > 0 && this.byDefaultSelectAllRows){
      this.byDefaultSelectAllRows = false;
      this.selectAllRows();
    }
  }


 async toggleSortDirection(column: string) {
    // Toggle the sort direction for the specified column
    this.sortDirections[column] = this.sortDirections[column] === 'asc' ? 'desc' : 'asc';

    this.sortBy = column;
    this.sortDirection = this.sortDirections[column];
       this.paginationOptions = {
      ...this.paginationOptions,
      sortBy: this._spExcelexportService.getSortedColumnNameForLocation(this.sortBy),
      sortOrder: this.sortDirection,
    };

    await this.getData();

    this._mixpanelService.track('Location Details Summary Row Drilldown - Header Sort Clicked', {
      'Column Name': column,
      'Page Name': 'Solution Participation - Location Details Drilldown',
    });
  }


  async exportAllToExcel() {
    const currentDate = new Date().toISOString().slice(0, 19).replace(/[-T:/]/g, '');
    const fileName = `EBR__Location_Details_${currentDate}_Solution.xlsx`;

    if(!this.rowSelection.includes(true)){
      alert('Please select at least one location to export.');
      return;
    }
    const columnName = this.drillBy === 'Product' ? 'PRODUCTCODE' : 'ACCOUNTNUMBER';
    if(!this.isAllSelected())
      this.applyAccountIdAndProductFiltersForExport(columnName);

    this.isDownloadingFile = true;
     let initializeDownload = true;
     const fileData = await this._solutionParticipation.DownloadExcel(this.spLocationExportFilterPayload).then(response => {
      if (response) {
         const { data } = response;
         return data;
       }
       initializeDownload = false;
       return null;
     }).catch(error => {
      initializeDownload = false;
      this.isDownloadingFile = false;
       console.log(JSON.stringify(error));
     });
      if (initializeDownload && fileData.size > 0) {
        this._spExcelexportService.executeBrowserDownload(fileData,fileName);

        this._mixpanelService.track('Solution Participation - Location Details -drilldown page - Export Button Clicked', {
          'No Of Records Downloaded and FileName': `${fileData.size} and ${fileName}`,
          'Page Name': 'Solution Participation - Location Details'});
      }else{
        alert('No data found to export.');
      }
      this.isDownloadingFile = false;
      this.spLocationExportFilterPayload.queryFilters = this.spLocationExportFilterPayload.queryFilters?.filter(filter =>
      !filter.columnFilters.hasOwnProperty(columnName));

   }

  applyAccountIdAndProductFiltersForExport(columnName:string) {

    if (this.selectedIds.length > 0) {
      this.upDateQueryFilter(columnName, this.selectedIds, 'In', 'And');
    } else if (this.notSelectedIds.length > 0) {
      this.upDateQueryFilter(columnName, this.notSelectedIds, 'Not In', 'And');
    }
  }




  onCheckboxChange(event: MatCheckbox, row: any, i: number): void {
    const pageSize = this.paginator.pageSize;
    const pageIndex = this.paginator.pageIndex;
    i = (pageSize*pageIndex) + i;
    this.rowSelection[i] = event.checked;

    const selectedId = this.drillBy === 'Product' ? row.productCode : row.accountNumber;
    // If the row is selected, add it to the selectedProduct SKUs / AccountNos.
    const selectedIdSet = new Set(this.selectedIds);
    const notselectedIdSet = new Set(this.notSelectedIds);
    if (event.checked) {
        selectedIdSet.add(selectedId);
        notselectedIdSet.delete(selectedId);
    } else {
        selectedIdSet.delete(selectedId);
        notselectedIdSet.add(selectedId);
    }
    this.selectedIds = Array.from(selectedIdSet);
    this.notSelectedIds = Array.from(notselectedIdSet);
    this.allRowsSelected = this.isAllSelected();
  }


  selectAllRows() {
    this.allRowsSelected = !this.allRowsSelected;
    for (let i = 0; i < this.totalRows; i++) {
      this.rowSelection[i] = this.allRowsSelected;
    }
    this.selectedIds = this.notSelectedIds = [];
    this.allRowsSelected = this.isAllSelected();
  }

  isAllSelected() {
    return !this.rowSelection.some(value => value === false);
  }

  getCurrency() {
     this.currencyCode = this._currencyUomService.getCurrencyCode();
  }

  transformData(locations:groupByLocation[]): SiteProductData[] {
    const siteProductData: SiteProductData[] = [];
    locations.forEach((location: groupByLocation) => {
    location.productInfo.forEach((product: any) => {
      const data: SiteProductData = {
        mdmSiteId: location.mdmSiteId,
        siteName: location.siteName,
        address: location.address,
        city: location.city,
        state: location.state,
        country: location.country,
        postalAddress: location.postalAddress,
        productName: product.productName,
        productCode: product.productCode,
        siteSalesAmount: location.totalSales.value,
        siteSalesQty: location.totalCases,
        accountNumber: location.accountNumber,
      };

      siteProductData.push(data);
    });
  });

  return siteProductData;
}

  upDateQueryFilter(
    columnName: string,
    filterValue: any,
    filterOperation: "In" | "Not In" | "Equals" | "ILike" | "=" | "!=",
    logicalOperator: "And" | "Or"
  ) {
    this._spExcelexportService.upsertQueryFilter(
      this.spLocationExportFilterPayload,
      columnName,
      filterValue,
      filterOperation,
      logicalOperator);
  }


}
